<template>
  <div class="container py-5">

    <h2 class="page-title mb-4">Graphic Design</h2>

    <p class="lead">
      Graphic design is the art of creating visual content to communicate ideas
      using typography, imagery, and layout.
    </p>

    <div class="card-section mt-4">
      <h4 class="section-title">🎨 What is Graphic Design?</h4>
      <p>
        It involves creating visuals such as posters, banners, logos, and social
        media designs.
      </p>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">🛠 Popular Design Tools</h4>
      <ul>
        <li>Adobe Photoshop</li>
        <li>Adobe Illustrator</li>
        <li>Canva</li>
        <li>Figma</li>
      </ul>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">📌 Design Elements</h4>
      <ul>
        <li>Color</li>
        <li>Typography</li>
        <li>Shapes</li>
        <li>Layout</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "GraphicDesign",
};
</script>

<style scoped>
.page-title { font-weight: 800; color: #2563eb; }
.lead { color: #374151; font-size: 1.1rem; }
.card-section {
  background: #fff; padding: 20px; border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border-left: 4px solid #2563eb;
}
.section-title { color: #1e40af; font-weight: 600; }
</style>
